import React from 'react';

import { Flex } from 'antd';

const FormRow = ({
  children,
  width,
}: {
  children: React.ReactNode;
  width?: string;
}) => (
  <Flex gap={24} style={{ width: width || '100%', alignItems: 'flex-start' }}>
    {children}
  </Flex>
);
export default FormRow;
